export default "__VITE_ASSET__BANkzj0d__"